import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { Card } from '../ui/Card';
interface MetricCardProps {
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  icon: React.ReactNode;
  color: 'primary' | 'secondary' | 'accent' | 'success';
}
export function MetricCard({
  title,
  value,
  change,
  trend,
  icon,
  color
}: MetricCardProps) {
  const colorStyles = {
    primary: 'bg-primary/10 text-primary',
    secondary: 'bg-secondary/10 text-secondary',
    accent: 'bg-accent/10 text-accent',
    success: 'bg-success/10 text-success'
  };
  return <Card className="p-6 relative overflow-hidden group" data-id="element-33">
      <div className="flex justify-between items-start" data-id="element-34">
        <div data-id="element-35">
          <p className="text-sm font-medium text-text-muted mb-1" data-id="element-36">{title}</p>
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-37">{value}</h3>

          <div className="flex items-center text-xs font-medium" data-id="element-38">
            <span className={`
              flex items-center mr-2 px-1.5 py-0.5 rounded
              ${trend === 'up' ? 'text-emerald-400 bg-emerald-500/10' : 'text-red-400 bg-red-500/10'}
            `} data-id="element-39">
              {trend === 'up' ? <ArrowUpRight className="h-3 w-3 mr-1" data-id="element-40" /> : <ArrowDownRight className="h-3 w-3 mr-1" data-id="element-41" />}
              {change}
            </span>
            <span className="text-text-muted" data-id="element-42">vs. mês anterior</span>
          </div>
        </div>

        <div className={`p-3 rounded-xl ${colorStyles[color]} transition-transform group-hover:scale-110 duration-300`} data-id="element-43">
          {icon}
        </div>
      </div>

      {/* Decorative background glow */}
      <div className={`absolute -right-6 -bottom-6 w-24 h-24 rounded-full blur-3xl opacity-20 ${colorStyles[color].split(' ')[0]}`} data-id="element-44" />
    </Card>;
}